export var version = '3.6.4';
//# sourceMappingURL=version.js.map